import IconButton from '@betterfunnel/ui-core/IconButton';
import { AssetData } from '@betterfunnel/types';
import { Dialog, DialogPanel } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { ImageViewer } from './ImageViewer';

interface Props {
  open: boolean;
  onClose: () => void;
  images: AssetData[];
}

export const ImageViewerModal = ({ images, open, onClose }: Props) => {
  return (
    <Dialog open={open} onClose={() => onClose()} className="relative z-50">
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel
          className="relative max-h-screen max-w-4xl rounded-lg bg-white shadow-lg"
          style={{ width: '900px', height: '600px' }}
        >
          <ImageViewer images={images} className="h-full" />
          <IconButton
            className="absolute right-4 top-4"
            onClick={() => onClose()}
          >
            <XMarkIcon className="h-6 w-6" />
          </IconButton>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
